var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ICountUp',{attrs:{"startVal":_vm.startVal,"endVal":_vm.endVal,"decimals":_vm.decimals,"duration":_vm.duration,"options":_vm.options},on:{"ready":_vm.onReady}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30e7e1fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-countup/index.vue
// module id = null
// module chunks = 